module.exports = __webpack_public_path__ + "static/img/logo.390df9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = dLd/
// module chunks = 1 19 21 26 27 30 32 33 35 36